import { gql } from '@apollo/client'
import { AGENCY_FIELDS } from '../fragments'

export const GET_VOOH_CAMPAIGNS_FOR_TABLE = gql`
  ${AGENCY_FIELDS}
  query voohCampaigns(
    $first: Int!
    $last: Int!
    $sortColumn: VoohCampaignsSortColumnEnum
    $sortDirection: SortDirectionEnum
    $filters: VoohCampaignFilters
  ) {
    voohCampaigns(
      first: $first
      last: $last
      sortColumn: $sortColumn
      sortDirection: $sortDirection
      filters: $filters
    ) {
      totalCount
      nodes {
        agency {
          ...AgencyFields
        }
        endDate
        id
        name
        startDate
        status
      }
    }
  }
`
